var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCautionIconColored(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2973 13.5007L10.2973 3.00066C10.1665 2.76981 9.97678 2.5778 9.74752 2.44421C9.51826 2.31062 9.25767 2.24023 8.99232 2.24023C8.72698 2.24023 8.46639 2.31062 8.23713 2.44421C8.00787 2.5778 7.81815 2.76981 7.68733 3.00066L1.68733 13.5007C1.55509 13.7297 1.48575 13.9896 1.48633 14.254C1.48692 14.5185 1.55741 14.7781 1.69066 15.0065C1.82391 15.235 2.01519 15.4241 2.2451 15.5548C2.47501 15.6855 2.73538 15.753 2.99983 15.7507H14.9998C15.263 15.7504 15.5215 15.6809 15.7493 15.5491C15.9771 15.4174 16.1662 15.228 16.2977 15C16.4292 14.772 16.4984 14.5134 16.4983 14.2503C16.4982 13.9871 16.4289 13.7286 16.2973 13.5007Z",
    stroke: "#2563EB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 6.75V9.75",
    stroke: "#2563EB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 12.75H9.0075",
    stroke: "#2563EB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCautionIconColored);
export default __webpack_public_path__ + "static/media/cautionIconColored.8e2da779a29e17382c1ef05490f269c9.svg";
export { ForwardRef as ReactComponent };